import { render, staticRenderFns } from "./ledgerPurchase.vue?vue&type=template&id=4bfcd22a&scoped=true"
import script from "./ledgerPurchase.vue?vue&type=script&lang=js"
export * from "./ledgerPurchase.vue?vue&type=script&lang=js"
import style0 from "./ledgerPurchase.vue?vue&type=style&index=0&id=4bfcd22a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfcd22a",
  null
  
)

export default component.exports